export default "__VITE_ASSET__Dgmuffe8__"